/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from 'react';
import {
  Direction,
  Margin,
  Text,
  TextCaption,
  IconTip,
  TextSmall,
  IconMoneyManagement,
  Column,
} from '@scotia/canvas-react';
import { Tooltip, DataPair } from '@cldf/scotiaweb-canvas-react';
import { MercuryGroup, MercuryZone } from 'mercury-react-sdk';
import styles from './AccountContent.scss';
import { ThreeColumnProductsLayout } from '../ThreeColumnProductsLayout';
import { DataProducts } from '../DataProducts';
import { DataBalance } from '../DataBalance';
import { CreditLineIcon } from '../../../../../assets/CreditLineIcon';
import { numberFormatter } from '../../Amounts.Converter';
import { SummaryContextMenu } from '../SummaryContextMenu';
import ToolTipText from './ToolTipText';
import { getSession, getSimpleAccount } from './utils';

const availableBalance = 'Saldo disponible';
const CONTENT_CARD_INFO = 'account-content-card-info';
const FONT_PRODUCTS = 'font-color-product';
const TOTAL_DISPONIBLE = 'Total disponible';
const CLIENT_ACCOUNTS = 'simple_accounts';
const CLIENT_COLOR = 'client_color';

const preparedArray = props => {
  const array = [...props.list.checking_accounts, ...props.list.debit_accounts, ...props.list.saving_accounts];

  return array.filter(arr => arr && arr.available_balance !== undefined);
};

const AccountContent = props => {
  const [isRedClient, setIsRedClient] = useState(undefined);

  const [simpleAccountNumber, setSimpleAccountNumber] = useState(undefined);

  const [mercuryApiUrl, setMercuryApi] = useState(undefined);

  const [mercuryRenderersUrl, setMercuryRenderersUrl] = useState(undefined);

  const [mercuryEnabled, setMercuryEnabled] = useState(undefined);

  useEffect(() => {
    getSession(setMercuryEnabled, setMercuryApi, setMercuryRenderersUrl);
  }, []);
  return (
    <Direction className={styles['account-content-container']}>
      {props.list !== null && (
        <div className={styles[CONTENT_CARD_INFO]}>
          {preparedArray(props).map((accountObject, i) => (
            <>
              <AccountProducts
                isRedClient={isRedClient}
                simpleAccountNumber={simpleAccountNumber}
                tooltipClick={number => {
                  /* istanbul ignore next */
                  getSimpleAccount(number, setSimpleAccountNumber, simpleAccountNumber, setIsRedClient);
                }}
                key={`account-product-${i + 1}`}
                account={accountObject}
                showSald={props.showSald}
              />
              {i === 0 && mercuryApiUrl && mercuryRenderersUrl && (
                <Margin side={'top'} xs={24} sm={24} md={24} lg={24}>
                  <MercuryGroup
                    apiUrl={mercuryApiUrl}
                    tokenUrl={'/cgi-bin/transac/dotrxajax?TMPL=/security/passport.json&intends='}
                    renderersUrl={mercuryRenderersUrl}
                    id="accounts_section_sweb"
                    withEventstream={false}
                    tokenExpireTime={40000}
                    interactionEnabled={mercuryEnabled}
                    onError={error => {
                      /* istanbul ignore next */
                      console.log('Error al cargar mercury', error);
                    }}
                  >
                    <MercuryZone id="accounts_section_sweb_1" />
                  </MercuryGroup>
                </Margin>
              )}
            </>
          ))}
        </div>
      )}
    </Direction>
  );
};

AccountContent.displayName = 'AccountContent';

const formatAccount = account => `**** ${account.substr(account.length - 4)}`;

export default AccountContent;

const isCheckingAccounts = productType => productType === 'checking_account';
const isDebitAccount = productType => productType === 'debit_account';
const isDailyAccount = productType => productType === 'Cuenta Renta Diaria';

const AccountProducts = props => (
  <div>
    {props.account !== '' && props.account !== null && (
      <div>
        <Margin
          key={props.account.product_information.id}
          md={24}
          xs={12}
          sm={12}
          lg={24}
          side={'top'}
          className={styles[CONTENT_CARD_INFO]}
        >
          <RendererAccountProduct
            {...props}
            productName={props.account.product_information.product_name}
            amount={props.account.available_balance.amount}
            idProduct={props.account.product_information.display_id}
            showSald={props.showSald}
            id={props.account.product_information.id}
            amountContable={props.account.countable_balance !== undefined && props.account.countable_balance.amount}
            currencyCodeCountable={
              props.account.countable_balance !== undefined && props.account.countable_balance.currency_code
            }
            productType={props.account.product_information.product_type}
            account={props.account.product_information.display_id.replace(/ /gi, '')}
          />
        </Margin>
        {isCheckingAccounts(props.account.product_information.product_type) &&
          props.account.lines_of_credit !== null &&
          props.account.lines_of_credit !== '' &&
          props.account.lines_of_credit !== undefined && (
            <Margin
              key={props.account.product_information.id}
              md={24}
              xs={12}
              sm={12}
              lg={24}
              side={'top'}
              className={styles[CONTENT_CARD_INFO]}
            >
              <div>
                {props.account.lines_of_credit.map(lineObject => (
                  /* istanbul ignore next */
                  <RendererAccountProduct
                    {...props}
                    productName={lineObject.product_information.product_name}
                    amount={lineObject.available_credit.amount}
                    idProduct={lineObject.product_information.display_id}
                    showSald={props.showSald}
                    id={lineObject.product_information.id}
                    productType={lineObject.product_information.product_type}
                    account={lineObject.product_information.display_id.replace(/ /gi, '')}
                  />
                ))}
              </div>
            </Margin>
          )}
      </div>
    )}
  </div>
);

const RendererAccountProduct = props => {
  /* istanbul ignore next */
  const cuenta = typeof props.isRedClient === 'undefined' || props.isRedClient ? 'Cuenta Corriente' : 'Recuerda';
  const _isCheking = isCheckingAccounts(props.productType) ? (
    <div>{`$${numberFormatter(props.amountContable)}`}</div>
  ) : (
    <div>{`$${numberFormatter(props.amount)}`}</div>
  );

  return (
    <ThreeColumnProductsLayout
      renderCol1={() => (
        <div style={{ padding: '0 15px 0 0' }}>
          <Direction type="row" className="hide--lg hide--md">
            <Column xs={6} sm={7}>
              {!isCheckingAccounts(props.productType) ? (
                <DataPair
                  title={<TextSmall className={styles[FONT_PRODUCTS]}>{props.productName}</TextSmall>}
                  text={
                    <TextSmall className={`${styles[FONT_PRODUCTS]} text--medium`}>{`$${numberFormatter(
                      props.amount
                    )}`}</TextSmall>
                  }
                />
              ) : (
                <div>
                  <DataPair
                    title={
                      <React.Fragment>
                        <TextSmall className={styles[FONT_PRODUCTS]}>{props.productName}</TextSmall>
                        <div
                          className="hide--xs hide--sm"
                          style={{
                            paddingLeft: '2px',
                            marginTop: '1px',
                            position: 'inline',
                            with: '93%',
                          }}
                        >
                          <Tooltip
                            title={cuenta}
                            closeOnClickOutside
                            text={
                              <ToolTipText
                                accountKey={props.id}
                                isRedClient={props.isRedClient}
                                simpleAccountNumber={props.simpleAccountNumber}
                              />
                            }
                          >
                            <div
                              onClick={() => {
                                /* istanbul ignore next */
                                props.tooltipClick(props.id);
                              }}
                            >
                              <IconTip color="highlight" size={18} />
                            </div>
                          </Tooltip>
                        </div>
                      </React.Fragment>
                    }
                  />
                  <DataPair
                    title={<TextSmall>{availableBalance}</TextSmall>}
                    text={
                      <TextSmall className={`${styles[FONT_PRODUCTS]} text--medium`}>{`$${numberFormatter(
                        props.amountContable
                      )}`}</TextSmall>
                    }
                  />
                  <DataPair
                    title={<TextSmall>{TOTAL_DISPONIBLE}</TextSmall>}
                    text={
                      <TextSmall className={`${styles[FONT_PRODUCTS]} text--medium`}>{`$${numberFormatter(
                        props.amount
                      )}`}</TextSmall>
                    }
                  />
                </div>
              )}
            </Column>
            <Column xs={5} sm={4}>
              <TextCaption className="text--light">{formatAccount(props.idProduct)}</TextCaption>
            </Column>
            <Column xs={1} sm={1}>
              <div
                style={{
                  display: 'flex',
                  marginRight: '-20px',
                  marginTop: '-3px',
                  paddingLeft: '4px',
                  float: 'right',
                }}
              >
                <SummaryContextMenu
                  productType={props.productType}
                  account={props.account}
                  productName={props.productName}
                  currencyCode={props.currencyCodeCountable}
                />
              </div>
            </Column>
          </Direction>
          <div className="hide--xs hide--sm">
            <DataProducts
              title={
                <div>
                  <div
                    style={{
                      display: 'inline-block',
                    }}
                  >
                    <Text className={`${styles[FONT_PRODUCTS]} text--roman`}>
                      {props.productName}
                      {isCheckingAccounts(props.productType) && (
                        <div
                          style={{
                            paddingLeft: '6px',
                            display: 'inline',
                            marginTop: '1px',
                            position: 'absolute',
                          }}
                        >
                          <Tooltip
                            title={
                              typeof props.isRedClient === 'undefined' || props.isRedClient
                                ? 'Cuenta Corriente'
                                : 'Recuerda'
                            }
                            closeOnClickOutside
                            text={
                              <ToolTipText
                                accountKey={props.id}
                                isRedClient={props.isRedClient}
                                simpleAccountNumber={props.simpleAccountNumber}
                              />
                            }
                          >
                            <div
                              onClick={() => {
                                /* istanbul ignore next */
                                props.tooltipClick(props.id);
                              }}
                            >
                              <IconTip color="highlight" size={18} />
                            </div>
                          </Tooltip>
                        </div>
                      )}
                    </Text>
                    <DataPair
                      title={
                        <div>
                          <TextSmall className={`hide--md hide--lg ${styles[FONT_PRODUCTS]}`}>
                            {props.productName}
                          </TextSmall>
                        </div>
                      }
                    />
                  </div>
                </div>
              }
              text={<TextSmall>{props.idProduct}</TextSmall>}
              icon={
                props.productType === 'Line of Credit' || props.productType === 'line_of_credit' ? (
                  <CreditLineIcon />
                ) : (
                  <IconMoneyManagement size={36} />
                )
              }
            />
          </div>
        </div>
      )}
      renderCol2={() => (
        <div className="hide--xs hide--sm">
          <DataBalance
            title={<TextSmall>{availableBalance}</TextSmall>}
            text={
              <Text className={`${styles[FONT_PRODUCTS]} text--medium`}>
                {props.showSald ? <div>{_isCheking}</div> : '*********'}
              </Text>
            }
          />
        </div>
      )}
      renderCol3={() => (
        <div className="hide--xs hide--sm">
          {isCheckingAccounts(props.productType) && (
            <DataBalance
              title={
                <React.Fragment>
                  <div style={{ display: 'inline-block' }}>
                    <TextSmall>{TOTAL_DISPONIBLE}</TextSmall>
                  </div>
                  <div
                    style={{
                      paddingLeft: '6px',
                      display: 'inline',
                      marginTop: '1px',
                      position: 'absolute',
                    }}
                  >
                    <Tooltip
                      title={<TextSmall className="text--bold">{TOTAL_DISPONIBLE}</TextSmall>}
                      text={
                        <div>
                          <TextCaption className="text--light" style={{ lineHeight: '1.4' }}>
                            Corresponde a la suma de tu <b>Saldo disponible</b> y tu <b>Línea de Crédito</b>
                          </TextCaption>
                        </div>
                      }
                      closeOnClickOutside
                    >
                      <IconTip color="highlight" size={18} />
                    </Tooltip>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      marginRight: '-30px',
                      marginTop: '-10px',
                      paddingLeft: '4px',
                      float: 'right',
                    }}
                  >
                    <SummaryContextMenu
                      productType={props.productType}
                      account={props.account}
                      productName={props.productName}
                      currencyCode={props.currencyCodeCountable}
                    />
                  </div>
                </React.Fragment>
              }
              text={
                <Text className={`${styles[FONT_PRODUCTS]} text--medium`}>
                  {props.showSald ? <div>{`$${numberFormatter(props.amount)}`}</div> : '*********'}
                </Text>
              }
            />
          )}
          <div
            style={{
              display: 'flex',
              marginRight: '-30px',
              marginTop: '-10px',
              paddingLeft: '4px',
              float: 'right',
            }}
          >
            {props.productType === 'line_of_credit' && (
              <SummaryContextMenu
                productType={props.productType}
                account={props.account}
                productName={props.productName}
              />
            )}

            {props.productType === 'saving_account' && (
              <SummaryContextMenu
                productType={props.productType}
                account={props.account}
                productName={props.productName}
              />
            )}

            {isDebitAccount(props.productType) && !isDailyAccount(props.productName) && (
              <SummaryContextMenu
                productType={props.productType}
                account={props.account}
                productName={props.productName}
              />
            )}

            {isDailyAccount(props.productName) && (
              <SummaryContextMenu
                productType={props.productType}
                account={props.account}
                productName={props.productName}
              />
            )}
          </div>
        </div>
      )}
      column1={5}
      column2={3}
      column3={4}
    />
  );
};
